module.exports = __webpack_public_path__ + "static/media/ShweThanLwin_Birmania.3f0d8a9f.png";